export default {
  reviews: {
    en: 'Reviews: <span class="count">{reviewsTotal}</span>',
  },
  likes: {
    en: 'Upvotes: <span class="count">{likeTotal}</span>',
  },
  dislikes: {
    en: 'Downvotes: <span class="count">{dislikeTotal}</span>',
  },
  productsReceived: {
    en: 'Products received: <span class="count">{shippedCount}</span>',
  },
}
